module.exports = __webpack_public_path__ + "static/img/ais_02.10d7593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ais_02.png
// module id = ROqf
// module chunks = 0